module.exports = __webpack_public_path__ + "static/img/unuse.18fad01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unuse.png
// module id = biYD
// module chunks = 1